import LinkIcon from "@mui/icons-material/Link";
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Link, useLocation } from "react-router-dom";

interface SidebarSubLinkProps {
  to: string;
  label: string;
}

const SidebarSubLink = ({ to, label }: SidebarSubLinkProps) => {
  const { pathname } = useLocation();
  const active = pathname.startsWith(to);

  return (
    <ListItem
      disablePadding
      sx={{
        ...(active && { backgroundColor: "sidebar.light" }),
        "&:hover": { backgroundColor: "sidebar.light" },
        "&.MuiListItem-divider": {
          borderBottomColor: "rgba(255,255,255,0.05)",
        },
      }}
      divider
    >
      <ListItemButton component={Link} to={to} sx={{ pt: 0, pl: 5, pr: 2 }}>
        <ListItemIcon
          sx={{
            minWidth: 0,
            color: "inherit",
            flexShrink: 0,
            mr: 1.5,
          }}
        >
          <LinkIcon fontSize="small" sx={{ opacity: 0.65 }} />
        </ListItemIcon>

        <ListItemText
          secondary={label}
          slotProps={{
            secondary: {
              color: "inherit",
              fontSize: 12,
              sx: {
                opacity: active ? 1 : 0.65,
                p: 0,
              },
            },
          }}
        />
      </ListItemButton>
    </ListItem>
  );
};

export default SidebarSubLink;
